import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithubAlt, faDev, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import style from '../../style/connect.module.css';

const icons = [
  {
    link: "https://github.com/lilyyanglt/",
    className: 'github',
    size: '2x',
    icon: faGithubAlt,
    color: '#24292E'
  },
  {
    link: "https://ca.linkedin.com/in/lily-yang-704a7765",
    className: 'linkedIn',
    size: '2x',
    icon: faLinkedin,
    color: '#1E76B5'
  },
  {
    link: "https://dev.to/lilyyanglt",
    className: 'dev',
    size: '2x',
    icon: faDev,
    color: 'black'
  }
]

export default function Connect() {
  return <div className={style.connect}>
     <p>Let's connect!</p>
     <div className={style.iconContainer}>
      {icons.map((icon, i) => <Icon key={i} content={icon} />)}
    </div>
  </div>
}

function Icon({content}) {
  return (
    <>
      <a href={content.link} className={style.icon}>
        <FontAwesomeIcon 
        icon={content.icon}
        size={content.size}
        color={content.color}
        />
      </a>
    </>
  )
}